/** The Connect panel's sections, in render order. */
export const PANEL_SECTIONS = [
  { id: "quick-start", title: "Set up in your terminal" },
  { id: "api", title: "Connect with API" },
] as const;

export type ConnectPanelSection = (typeof PANEL_SECTIONS)[number]["id"];

/** Where the panel opens (and open() resets to): the list's first section. */
export const DEFAULT_PANEL_SECTION: ConnectPanelSection = PANEL_SECTIONS[0].id;

export function isConnectPanelSection(value: string | null): value is ConnectPanelSection {
  return PANEL_SECTIONS.some((section) => section.id === value);
}
